import {mapState, mapGetters, mapMutations, mapActions} from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'data',
    ]),
  },
  data() {
    return {
      isInitialized: null,
    }
  },
  methods: {
    ...mapActions([
      'setArray',
      'setData',
      'setValue',
      'clearData',
      'fetchData',
    ]),
    requestFetchData(request){
      this.fetchData({
        key: request.key,
        url: request.url,
        mode: request.mode || 'masters'
      }).then(() => {
        this.isInitialized = true
        this.initialized()
      }).catch((error) => {
        console.log(error);
      });
    }
  }
}
